import { StorePack } from "../../../entity/StorePack";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { StorePackDto } from "../../dto/StorePack.Dto";
import { mapStorePackDtoToStorePack } from "../../mapper/PackMapper";

export default class WSPayment {
  private static instance: WSPayment;

  private constructor() {}

  public static getInstance(): WSPayment {
    if (!WSPayment.instance) {
      WSPayment.instance = new WSPayment();
    }
    return WSPayment.instance;
  }

  async getStorePacks(): Promise<StorePack[]> {
    try {
      const url = ROUTES.PACKS;
      const response = await fetchAPI<StorePackDto[]>({
        url,
        method: Method.GET,
        isAuthenticated: false,
      });
      return mapStorePackDtoToStorePack(response.data);
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async createPack(pack: StorePack): Promise<string> {
    try {
      const url = ROUTES.PACKS + ROUTES.CREATE_PACK;
      const response = await fetchAPI<string>({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: pack,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async update(pack: StorePack): Promise<void> {
    try {
      const url = ROUTES.PACKS + ROUTES.UPDATE_PACK;
      const response = await fetchAPI<void>({
        url,
        method: Method.PUT,
        isAuthenticated: true,
        params: pack,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async delete(packId: string): Promise<void> {
    try {
      const url = ROUTES.PACKS + ROUTES.DELETE + "/" + packId;
      const response = await fetchAPI<void>({
        url,
        method: Method.DELETE,
        isAuthenticated: true,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
